
import React from "react";
import { Label } from "@/components/ui/label";
import { Check } from "lucide-react";
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger 
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "../StatusBadges";
import { getStatusDisplayName } from "@/utils/statusMappings";

interface StatusSelectProps {
  status: string;
  onStatusChange: (value: string) => void;
  readOnly?: boolean;
  label?: string;
  required?: boolean;
}

const StatusSelect = ({ 
  status, 
  onStatusChange, 
  readOnly = false,
  label = "Status",
  required = true
}: StatusSelectProps) => {
  if (readOnly) {
    return (
      <div className="space-y-2">
        <Label htmlFor="status" className="flex">
          {label}
        </Label>
        <div className="mt-2">
          <StatusBadge status={status} />
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <Label htmlFor="status" className="flex">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </Label>
      
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button 
            variant="outline" 
            className="w-full justify-start text-left font-normal"
            id="status"
          >
            <StatusBadge status={status} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-60 max-h-[300px] overflow-y-auto">
          <DropdownMenuItem
            className={status === "actie_luijten" ? "bg-slate-100" : ""}
            onClick={() => onStatusChange("actie_luijten")}
          >
            <StatusBadge status="actie_luijten" />
            <span className="ml-2">Actie Luijten</span>
            {status === "actie_luijten" && <Check size={16} className="ml-2" />}
          </DropdownMenuItem>
          
          <DropdownMenuItem
            className={status === "actie_decoprof" ? "bg-slate-100" : ""}
            onClick={() => onStatusChange("actie_decoprof")}
          >
            <StatusBadge status="actie_decoprof" />
            <span className="ml-2">Actie Decoprof</span>
            {status === "actie_decoprof" && <Check size={16} className="ml-2" />}
          </DropdownMenuItem>
          
          <DropdownMenuItem
            className={status === "actie_winkel_ridderkerk" ? "bg-slate-100" : ""}
            onClick={() => onStatusChange("actie_winkel_ridderkerk")}
          >
            <StatusBadge status="actie_winkel_ridderkerk" />
            <span className="ml-2">Actie winkel Ridderkerk</span>
            {status === "actie_winkel_ridderkerk" && <Check size={16} className="ml-2" />}
          </DropdownMenuItem>
          
          <DropdownMenuItem
            className={status === "afwachting_klant" ? "bg-slate-100" : ""}
            onClick={() => onStatusChange("afwachting_klant")}
          >
            <StatusBadge status="afwachting_klant" />
            <span className="ml-2">In afwachting van klant</span>
            {status === "afwachting_klant" && <Check size={16} className="ml-2" />}
          </DropdownMenuItem>
          
          <DropdownMenuItem
            className={status === "afwachting_voorraad" ? "bg-slate-100" : ""}
            onClick={() => onStatusChange("afwachting_voorraad")}
          >
            <StatusBadge status="afwachting_voorraad" />
            <span className="ml-2">In afwachting van nieuwe voorraad</span>
            {status === "afwachting_voorraad" && <Check size={16} className="ml-2" />}
          </DropdownMenuItem>
          
          <DropdownMenuItem
            className={status === "afwachting_voorraad_ridderkerk" ? "bg-slate-100" : ""}
            onClick={() => onStatusChange("afwachting_voorraad_ridderkerk")}
          >
            <StatusBadge status="afwachting_voorraad_ridderkerk" />
            <span className="ml-2">In afwachting van nieuwe voorraad winkel Ridderkerk</span>
            {status === "afwachting_voorraad_ridderkerk" && <Check size={16} className="ml-2" />}
          </DropdownMenuItem>
          
          <DropdownMenuItem
            className={status === "afwijkende_verzenddatum" ? "bg-slate-100" : ""}
            onClick={() => onStatusChange("afwijkende_verzenddatum")}
          >
            <StatusBadge status="afwijkende_verzenddatum" />
            <span className="ml-2">Afwijkende verzenddatum</span>
            {status === "afwijkende_verzenddatum" && <Check size={16} className="ml-2" />}
          </DropdownMenuItem>
          
          <DropdownMenuItem
            className={status === "afgerond" ? "bg-slate-100" : ""}
            onClick={() => onStatusChange("afgerond")}
          >
            <StatusBadge status="afgerond" />
            <span className="ml-2">Afgerond</span>
            {status === "afgerond" && <Check size={16} className="ml-2" />}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default StatusSelect;
